import { render, staticRenderFns } from "./BacktestPainel.vue?vue&type=template&id=18a885e9&"
import script from "./BacktestPainel.vue?vue&type=script&lang=js&"
export * from "./BacktestPainel.vue?vue&type=script&lang=js&"
import style0 from "./BacktestPainel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports